import { NavLink } from "react-router-dom";
import LightGearIcon from "../../components/WebDesigner/Icons/LightGearIcon";
import PageIcon from "../../components/WebDesigner/Icons/PageIcon";
import EditIcon from "../../components/WebDesigner/Icons/EditIcon";
import "./LeftPanel.scss";
import { useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { Fragment } from "react";
import ConnectDomainClickAd from "components/WebDesigner/Adds/ConnectDomainClickAd";
import { MultiLocationLive } from "components/Multilocation/MulitLocationLIve";
import { LoginUserType, utils } from "utils/Utils";

const Leftpanel = (props) => {
     const { ReactBusinessId, IsPurchasedDomain, IsMutipleLocation, UserType } = useSelector((state) => state.Business);

     const { StyleId, LayoutId } = useParams();
     let windowLocationnew = window.location.href;
     let folder = windowLocationnew.indexOf("admin/") > 0 ? "admin" : "business"
     let designer = {
          onDeselectMenu:()=> {},
          openSettingsMenu:()=> {},
          openToDomainSettings:()=> { window.location.pathname = `${'/' + folder + '/' + StyleId + "/" + LayoutId + "/domain"}`},
     }

       if(ReactBusinessId < 0 ) return null;
     return (

          <div className="panel-container left expanded">
               <div className="vg-tabs-wrapper">
                    {/* main 3 tabss */}
                    <ul className="vg-tabs nav">
                         <li className="has-settingIcon">
                              <NavLink
                                   className={
                                        props.activateTab === "GeneralSetting"
                                             ? "tab-link active"
                                             : "tab-link"
                                   }
                                   to={{ pathname: `${'/' + folder + '/' + StyleId + "/" + LayoutId + "/generalsetting"}` }}
                              >
                                   {/* <i className="far fa-cog"></i> */}
                                   <LightGearIcon className="settingIcon" />
                              </NavLink>
                         </li>
                         <li className="has-pageIcon">
                              <NavLink
                                   className={
                                        props.activateTab === "WebsiteBuilder"
                                             ? "tab-link active"
                                             : "tab-link"
                                   }
                                   to={'/' + folder + '/' + StyleId + "/" + LayoutId + "/designer?menu=pages"}
                              >
                                   {/* <i className="fal fa-file"></i> */}
                                   <PageIcon className="pageIcon" />
                              </NavLink>
                         </li>
                         <li className="has-editIcon">
                              <NavLink
                                   className={
                                        props.activateTab === "WebTools"
                                             ? "tab-link active"
                                             : "tab-link"
                                   }
                                   to={{ pathname: `${'/' + folder + '/' + StyleId + "/" + LayoutId + "/designer"}` }}
                              >
                                   {/* <i className="far fa-pencil-alt"></i> */}
                                   <EditIcon className="editIcon" />
                              </NavLink>
                         </li>
                    </ul>
                    {/* end main 3 tabss */}
               </div>
               <div className="vg-tabs-content tab-content">
                    <div className="vg-tab-item tab-pane active show">
                         <h4 className="tab-title">Settings</h4>
                         <div className="tab-links">
                              {ReactBusinessId > 0 &&
                                   <Fragment>
                                        <NavLink
                                             className={
                                                  props.activatePage === "GeneralSetting"
                                                       ? "tab-link active"
                                                       : "tab-link"
                                             }
                                             to={{ pathname: `${'/' + folder + '/' + StyleId + "/" + LayoutId + "/generalsetting"}` }}
                                        >
                                             General
                                        </NavLink>
                                        <NavLink
                                             className={
                                                  props.activatePage === "Domain"
                                                       ? "tab-link active"
                                                       : "tab-link"
                                             }
                                             to={{ pathname: `${'/' + folder + '/' + StyleId + "/" + LayoutId + "/domain"}` }}
                                        >
                                             Domains
                                        </NavLink>
                                        <NavLink
                                             className={
                                                  props.activatePage === "ChangeTheme"
                                                       ? "tab-link active"
                                                       : "tab-link"
                                             }
                                             to={{ pathname: `${'/' + folder + '/' + StyleId + "/" + LayoutId + "/changestyle"}` }}
                                        >
                                             Change Theme
                                        </NavLink>
                                        <NavLink
                                             className={
                                                  props.activatePage === "ChangeLayout"
                                                       ? "tab-link active"
                                                       : "tab-link"
                                             }
                                             to={{ pathname: `${'/' + folder + '/' + StyleId + "/" + LayoutId + "/changelayout"}` }}>
                                             Change Layout
                                        </NavLink>
                                        {IsMutipleLocation && (MultiLocationLive || UserType === LoginUserType.VagaroAdmin) &&
                                            
                                             <NavLink
                                                  className={
                                                       props.activatePage === "Multilocation"
                                                            ? "tab-link active"
                                                            : "tab-link"
                                                  }
                                                  to={{ pathname: `${'/' + folder + '/' + StyleId + "/" + LayoutId + "/multilocation"}` }}>
                                                  Multi-Location 
                                             </NavLink>
                                                  
                                            
                                        }
                                   </Fragment>
                              }
                              <NavLink
                                   className={
                                        props.activatePage === "designer"
                                             ? "tab-link active"
                                             : "tab-link"
                                   }
                                   to={'/' + folder + '/' + StyleId + "/" + LayoutId + "/designer?menu=sitestyling"}
                              >
                                   Site Styling
                              </NavLink>
                         </div>
                    </div>
                 </div>
               <ConnectDomainClickAd DomainNotPurcheshed={IsPurchasedDomain === false && props.activatePage !== "Domain"} designer={designer}/>
               {/* <button type="button" className="invisible-button send-feedback-editor-btn"><a href="https://form.asana.com/?k=VTzMLzamWdeQN006ciYNYA&d=35883393372079" target="_blank">Send Feedback</a></button> */}
               <div className="need-help-drop">
                    <button type="button" className="invisible-button send-feedback-editor-btn">Need Help?</button>
                    <div className="need-dropdown">
                         <a href="/admin/designservicepage" target="_blank" className="need-link">Get Our Design Team to Build It</a>
                         {/* Add MySite: Link to Webinar */}
                         <a href={`${utils.MySiteName()}/vagarouniversity`} target="_blank" rel="noreferrer" className="need-link">Get a Crash Course</a>
                         <a href="https://support.vagaro.com/hc/en-us/categories/20043786980251?_gl=1*jisjui*_gcl_au*MTMyNjg2MjYzNy4xNzA5NjczNzAx*_ga*MTY0MTcyMzI0MC4xNjY5Njc3NDgz*_ga_BGSFEW1QY1*MTcxMDI3ODU0Mi45NTQuMS4xNzEwMjc5NDM2LjU1LjAuMA" target="_blank" className="need-link">View Support Articles</a>
                         <a href="https://form.asana.com/?k=VTzMLzamWdeQN006ciYNYA&d=35883393372079" target="_blank" className="need-link">Send Feedback</a>
                    </div>
               </div>
          </div>
     );
};

export default Leftpanel;
